export default __webpack_public_path__ + "static/yard-waste-removal-icon-cbfe071fd7d2d3151ecd8b4b8085fab5.png";